import { render, staticRenderFns } from "./goodBookDetails.vue?vue&type=template&id=452abdcc&"
import script from "./goodBookDetails.vue?vue&type=script&lang=js&"
export * from "./goodBookDetails.vue?vue&type=script&lang=js&"
import style0 from "./goodBookDetails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports